module.exports = __webpack_public_path__ + "static/media/view_claims_3.bddf4c3c.png";